<template>
  <page>
    <template slot="header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h3 class="m-0 text-dark font-weight-normal">
              <button @click="sendBackPage" class="btn btn-dark mr-2">
                <i class="fas fa-angle-double-left"></i>
                {{ $t('Voltar') }}
              </button> #<strong>{{ $route.params.id }}</strong> - {{ this.nr_placa }}
            </h3>
          </div>
          <div class="col-12 col-sm-5 pt-sm-2">
            <b-breadcrumb class="float-md-right float-sm-left" :items="breadcrumbItems"></b-breadcrumb>
          </div>
        </div>
      </div>
    </template>

    <template slot="content">
      <div class="row">
        <div class="col-12" v-if="isEncerrada">
          <div class="alert alert-danger font-weight-bold text-center mb-3 shadow-sm" role="alert">
            <i class="fas fa-lock mr-2"></i> {{ mensagemBloqueio }}
          </div>
        </div>
        <div class="col-12">
          <os-details></os-details>
        </div>
        <div class="col-12">
          <os-items-list></os-items-list>
        </div>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsItemsList from '@/components/OsItemsList'
import OsDetails from '@/components/OsDetails'

export default {
  components: {
    Page,
    OsDetails,
    OsItemsList
  },

  data() {
    return {
      isDetalhesVisible: false,
      breadcrumbItems: [
        {
          text: this.$t('Ordens de Serviço'),
          to: '/'
        },
        {
          text: `${this.$route.params.id}`,
          active: true
        }
      ],
      nrSeqOs: this.$route.params.id,
      nr_placa: ''
    }
  },

  computed: {
    os() {
      return this.$store.getters['os/details']
    },
    isEncerrada() {
      return this.os && this.os.st_os && this.os.st_os !== 'A' && this.os.st_os !== 'R'
    },
    mensagemBloqueio() {
      if (this.os && this.os.st_os === 'C') {
        return this.$t('Esta Ordem de Serviço está cancelada no GINFO. O atendimento não pode mais ser alterado.')
      }
      return this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.')
    },
    linkVoltar() {
      const filial = this.$store.getters['filial/filial']

      if (filial.fornecExt === 'S') {
        return '/osExterna'
      } else {
        return '/'
      }
    }
  },

  mounted() {
    this.getOs()
      .then(response => {
        this.$store.commit('colaborador/setFuncaoColaborador', response.data.departamento)
        this.getLoadMecanicos()
        if (response.data.nr_seq_tipo == 'V' || response.data.nr_seq_tipo == 'R' || response.data.tp_os == 'V' || response.data.tp_os == 'R') {
          this.getOsItemsPreventiva()
          this.nr_placa = response.data.nr_placa
          return response
        } else {
          this.getOsItems()
          this.nr_placa = response.data.nr_placa
          return response
        }
      })
      .catch(error => {
        console.error(error)
        this.$swal.fire({
          title: 'Oops!',
          text: this.$t('Falha ao carregar os dados da OS'),
          icon: 'error'
        })
      })

      
  },

  methods: {
    getLoadMecanicos() {
      this.$store.dispatch('colaborador/loadMecanicos')
    },

    sendBackPage() {
      window.history.back()
    },
    async getOs() {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.nrSeqOs
      })
    },

    getOsItems() {
      this.$store
        .dispatch('osItem/fetchFromApi', {
          nrSeqOs: this.nrSeqOs
        })
        .catch(error => {
          console.error(error)
          this.$swal.fire({
            title: 'Oops!',
            text: this.$t('Falha ao carregar os itens da OS'),
            icon: 'error'
          })
        })
    },

    getOsItemsPreventiva() {
      this.$store
        .dispatch('osItem/fetchFromApiPreventiva', {
          nrSeqOs: this.nrSeqOs
        })
        .catch(error => {
          console.error(error)
          this.$swal.fire({
            title: 'Oops!',
            text: this.$t('Falha ao carregar os itens da OS'),
            icon: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon--custom {
  top: 50px;
}
</style>
